// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lf9Y","col":"styles_col__2UIkQ","actions":"styles_actions__3ktTc","conflict":"styles_conflict__3wjOp"};